/* VastraGharr Luxe - countdown banner (v3)
 * <vg-countdown data-end="ISO date"> ticks once a second, aligned to the wall clock, only while the band is
 * on screen and the tab is visible. Digit changes use the Web Animations API (no forced reflow).
 * When the countdown ends the timer and message swap inside one grid cell, so the band never jumps.
 * "Hide the whole section" collapses the band only while it is below the viewport; if the shopper is looking
 * at it (or past it) the end message shows instead, so nothing shifts under them.
 */
(function () {
  if (customElements.get('vg-countdown')) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class VgCountdown extends HTMLElement {
    connectedCallback() {
      var endAttr = this.getAttribute('data-end');
      if (!endAttr || this.bound) return;

      this.end = Date.parse(endAttr);
      this.timer = this.querySelector('[data-vg-cd-timer]');
      this.expiredEl = this.querySelector('[data-vg-cd-expired]');
      this.caption = this.querySelector('[data-vg-cd-caption]');
      this.daysUnit = this.querySelector('.vg-countdown__unit--days');
      this.section = this.closest('.shopify-section');

      if (!this.timer || isNaN(this.end)) {
        if (this.timer) this.timer.hidden = true;
        return;
      }

      this.bound = true;
      this.nums = {
        days: this.querySelector('[data-vg-cd="days"]'),
        hours: this.querySelector('[data-vg-cd="hours"]'),
        minutes: this.querySelector('[data-vg-cd="minutes"]'),
        seconds: this.querySelector('[data-vg-cd="seconds"]'),
      };

      this.tick = this.tick.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
      document.addEventListener('visibilitychange', this.onVisibility);

      this.onScreen = true;
      if ('IntersectionObserver' in window) {
        var self = this;
        this.observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[entries.length - 1];
            self.onScreen = entry.isIntersecting;
            if (self.expired) return;
            if (self.onScreen && !document.hidden) {
              self.tick(true);
              self.start();
            } else {
              self.stop();
              self.scheduleEnd();
            }
          },
          { rootMargin: '120px 0px' }
        );
        this.observer.observe(this);
      }

      this.tick(true);
      if (!this.expired) this.start();
    }

    disconnectedCallback() {
      if (!this.bound) return;
      this.bound = false;
      this.stop();
      clearTimeout(this.endTimeout);
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      this.stop();
      clearTimeout(this.endTimeout);
      var self = this;
      var delay = 1000 - (Date.now() % 1000);
      this.alignTimeout = setTimeout(function () {
        self.tick();
        if (!self.expired) self.interval = setInterval(self.tick, 1000);
      }, delay);
    }

    stop() {
      clearTimeout(this.alignTimeout);
      clearInterval(this.interval);
    }

    /* Off screen: no ticking, just one timer for the moment the countdown ends. */
    scheduleEnd() {
      clearTimeout(this.endTimeout);
      var left = this.end - Date.now();
      if (left <= 0 || left > 2147483000) return;
      var self = this;
      this.endTimeout = setTimeout(function () {
        self.tick(true);
      }, left + 50);
    }

    onVisibility() {
      if (this.expired) return;
      if (document.hidden) {
        this.stop();
      } else if (this.onScreen) {
        this.tick(true);
        this.start();
      }
    }

    set(unit, value, silent) {
      var el = this.nums[unit];
      if (!el) return;
      var text = pad(value);
      if (el.textContent === text) return;
      el.textContent = text;
      if (silent || reduceMotion() || typeof el.animate !== 'function') return;
      el.animate(
        [
          { opacity: 0.25, transform: 'translateY(-0.45em)' },
          { opacity: 1, transform: 'none' },
        ],
        { duration: 520, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
      );
    }

    tick(silent) {
      var diff = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      var days = Math.floor(diff / 86400);

      if (this.daysUnit) this.daysUnit.classList.toggle('is-wide', days > 99);
      this.set('days', days, silent);
      this.set('hours', Math.floor((diff % 86400) / 3600), silent);
      this.set('minutes', Math.floor((diff % 3600) / 60), silent);
      this.set('seconds', diff % 60, silent);

      if (diff <= 0) this.finish();
    }

    finish() {
      if (this.expired) return;
      this.expired = true;
      this.stop();
      clearTimeout(this.endTimeout);
      this.classList.add('is-expired');

      var behavior = this.getAttribute('data-expired-behavior');
      var designMode = this.hasAttribute('data-design-mode') || (window.Shopify && window.Shopify.designMode);
      var rect = this.getBoundingClientRect();
      var belowViewport = rect.top > window.innerHeight;

      if (behavior === 'hide' && !designMode && belowViewport) {
        if (this.section) {
          this.section.hidden = true;
          this.section.style.display = 'none';
        } else {
          this.hidden = true;
        }
        return;
      }

      this.timer.hidden = true;
      if (this.caption) this.caption.hidden = true;
      if (this.expiredEl && this.expiredEl.textContent.trim() !== '') this.expiredEl.hidden = false;
    }
  }

  customElements.define('vg-countdown', VgCountdown);
})();
